import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '@/views/index'
// import Agreement from "@/views/Agreement";
// import privatePolicy from '@/views/privatePolicy'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: Index
  },
  // {
  //   path: "/agreement",
  //   name: "agreement",
  //   component: Agreement,
  // },
  // {
  //   path: "/privatepolicy",
  //   name: "privatepolicy",
  //   component: privatePolicy,
  // },
]

const router = new VueRouter({
  routes
})

export default router
